import FJActionConstant from "../../constant/FJActionConstant";
import {FJMediaAction, FJModalAction} from "./FJRoot.action";
import FJCloudStore from "../../store/FJCloudStore";
import FJMedia from "../../store/FJMedia";
import FJUtil from "../../util/FJUtil";
import FJNetworkStore from "../../store/FJNetworkStore";
import FJViewConstant from "../../constant/FJViewConstant";
import FJLocalStore from "../../store/FJLocalStore";
import FJMediaStore from "../../store/FJMediaStore";

const repeatCloudSyncNumberWhenError = 3;
let aReadyCloudSyncNumber = 0;
let cloudErrorTimeout = null;
let expiredData = new Map();

/**
 * @description 云上传失败后默认间隔2s重新再上传， 一共3次
 * @param callback
 * @private
 */
let _cloudErrFunc = (callback) => {
  if (aReadyCloudSyncNumber === repeatCloudSyncNumberWhenError) {
    if (cloudErrorTimeout)
      cloudErrorTimeout = null;
    callback();
    return;
  }
  if (aReadyCloudSyncNumber === 0) {
    aReadyCloudSyncNumber++;
    callback('next');
  } else {
    cloudErrorTimeout = setTimeout(() => {
      aReadyCloudSyncNumber++;
      callback('next');
    }, 2000);
  }
};

let FJCloudAction = (function () {
  return {
    /**
     * @description 改变云空间的状态
     * @param data
     * @returns {{data: *, type: *}}
     */
    changeCloudStatusAction: function (data) {
      return {
        type: FJActionConstant.CLOUD_STATUS_CHANGED,
        data,
      }
    },

    /**
     * @description 设置显示云空间的升级弹窗
     * @returns {Function}
     */
    showCloudBenefitModalAction: function () {
      return (dispatch) => {
        dispatch(FJModalAction.setIsShowCloudBenefitModalAction(true));
      }
    },

    /**
     * @description 获取云空间的大小
     * @returns {Function}
     */
    getCloudZoneAction: function () {
      return (dispatch, getState) => {
        FJNetworkStore.getCloudSpace().then(res => {
          dispatch({
            type: FJActionConstant.CLOUD_SPACE_CHANGED,
            data: res
          });
          dispatch(this.dealCloudZoneAction())
        });
      }
    },

    /**
     * @description 判断云空间使用是否快要满
     * @returns {Function}
     */
    dealCloudZoneAction: function () {
      return (dispatch, getState) => {
        let space = getState().cloud.space;
        if (space.total === 0 && space.used === 0)
          return;

        if (space.total <= space.used) {
          dispatch(this.changeCloudStatusAction(FJActionConstant.CLOUD_STATUS_FULL));
        }
      }
    },

    /**
     * @description 云存储前的判断
     * @returns {Function}
     */
    doCheckWhenCloudSyncAction: function () {
      return (dispatch, getState) => {
        const state = getState();
        if (state.payment.paymentLevel === FJViewConstant.USER_PAYMENT_FREE) {
          return;
        }
        FJCloudStore.setMediaWaitingUpload();
        dispatch(this.updateALLCloudStatusAction());
        dispatch(this.clearCloudFullMediaAction());
        dispatch(this.cloudSyncAction());
      }
    },

    /**
     * 更新所有素材的云存储状态
     * @returns {(function(*): void)|*}
     */
    updateALLCloudStatusAction: function () {
      return (dispatch) => {
        dispatch({
          type: FJActionConstant.CLOUD_STATUS_UPDATE_ALL,
          data: FJCloudStore.getMediaListCloudStatus()
        });
        dispatch(FJMediaAction.updateMediasAction())
      }
    },

    /**
     * 同步媒体素材云到云端
     * @returns {(function(*): void)|*}
     */
    cloudSyncAction: function () {
      return (dispatch, getState) => {
        if (FJCloudStore.getUploadingMedia()) {
          return
        }
        let media = FJCloudStore.getNextMediaForUpload();
        if (media) {
          dispatch(this.changeCloudStatusAction(FJActionConstant.CLOUD_STATUS_SYNC));
          dispatch(this.startUploadMediaAction(media));
        } else {
          const state = getState();
          const failed = state.cloud.failed;
          const cloudFUllMediaList = getState().cloud.cloudFUllMediaList;

          let cloudStatus = FJActionConstant.CLOUD_STATUS_IDLE;
          if (failed.length > 0 && cloudFUllMediaList.length !== failed.length) {
            cloudStatus = FJActionConstant.CLOUD_STATUS_FAIL;
          } else if (failed.length > 0 && cloudFUllMediaList.length === failed.length) {
            cloudStatus = FJActionConstant.CLOUD_STATUS_FULL;
          }

          dispatch(this.changeCloudStatusAction(cloudStatus));

          if (failed.length > 0 && cloudFUllMediaList.length !== failed.length) {
            if (this._tryAgainCloudTimeout) {
              clearTimeout(this._tryAgainCloudTimeout);
              this._tryAgainCloudTimeout = null;
            }
            this._tryAgainCloudTimeout = setTimeout(() => {
              dispatch(this.doCheckWhenCloudSyncAction())
            }, 30000);
          }
        }
      }
    },

    /**
     * 开始上传素材到云端
     * @param media
     * @param isNeedClearErrorCount 是否需要清空 失败后重新上传该资源的次数
     * @returns {(function(*, *): Promise<void>)|*}
     */
    startUploadMediaAction: function (media, isNeedClearErrorCount = true) {

      let curTime = Date.now();
      expiredData.set(media.id, curTime);
      let isExpired = () => {
        return !FJCloudStore.checkMediaIsUploadIngById(media.id) || expiredData.get(media.id) > curTime;
      };

      return async (dispatch) => {

        if (!media || !FJMediaStore.hasMedia(media.id)) return;

        if (isNeedClearErrorCount)
          aReadyCloudSyncNumber = 0;

        media.setCloudStatus(FJMedia.CLOUD_STATUS().UPLOADING);
        media.setUploadProgress(0);

        // 组合上传云端的路径，格式为：/media/{uid}/{video/audio/photo}/{media.id.ext}
        let uid = (window.fjuser && window.fjuser.info) ? window.fjuser.info.id : 3;
        let type = "photo";
        if (media.type === FJMedia.MediaType().VIDEO) {
          type = "video"
        } else if (media.type === FJMedia.MediaType().AUDIO) {
          type = "audio"
        }
        let key = FJUtil.getS3Key(media);

        // 获取媒体用于上传到云端的数据
        let __getMediaData = (blob) => {
          let data = {
            key: media.id,
            name: blob.name ? blob.name : media.name,
            size: blob.size,
            type: type,
            time: 0, // TODO 替换为本地添加媒体的时间戳
          };
          if (media.type === FJMedia.MediaType().VIDEO) {
            data.info = {
              duration: media.duration,
              size: media.size
            }
          } else if (media.type === FJMedia.MediaType().AUDIO) {
            data.info = {
              duration: media.duration
            }
          } else {
            data.info = {
              size: media.size
            }
          }
          data.info = JSON.stringify(data.info);

          if (process.env.SERVE_ENV === 'local') // 本地测试
            data.uid = uid;

          return data;
        };

        // 上传云空间已满
        let __uploadFull = () => {
          media.setUploadProgress(0);
          FJCloudStore.mediaUploadEnd(false);
          dispatch(this.updateALLCloudStatusAction());
          dispatch(this.addCloudFullMediaAction(media));
          dispatch(this.cloudSyncAction());
        };


        // 上传失败回调
        let __uploadFailed = (dispatch) => {
          media.setUploadProgress(0);
          _cloudErrFunc((type) => {
            switch (type) {
              case 'next': {
                dispatch(this.startUploadMediaAction(media, false));
                break;
              }
              default: {
                FJCloudStore.mediaUploadEnd(false);
                dispatch(this.updateALLCloudStatusAction());
                dispatch(this.cloudSyncAction());
              }
            }
          });
        };

        // 上传成功回调
        let __uploadCompleted = (dispatch) => {
          media.setUploadProgress(1);
          FJCloudStore.mediaUploadEnd(true);
          dispatch(this.updateALLCloudStatusAction());
          dispatch(this.cloudSyncAction());
        };

        // 更新云端数据库
        let __uploadMediaData = (dispatch, blob) => {
          if (FJMediaStore.hasMedia(media.id)) {
            FJNetworkStore.uploadCloudMediaInfo(__getMediaData(blob)).then(code => {
              switch (code) {
                case 200: {
                  FJCloudStore.setMediaUploadIngProgress(1);
                  FJCloudStore.mediaUploadEnd(true);
                  dispatch(this.updateALLCloudStatusAction());
                  dispatch(this.cloudSyncAction());

                  break;
                }
                default: {
                  __uploadFailed(dispatch);
                }
              }
            }).catch((e) => {
              if (e.statusText === 'abort') {
                FJCloudStore.clearUploadMedia();
                dispatch(this.doCheckWhenCloudSyncAction())
              } else {
                __uploadFailed(dispatch);
              }
            });
          } else {
            __uploadFailed(dispatch);
          }
        };

        let mediaCache = media.getMediaCache();
        if (!FJMediaStore.hasMedia(media.id) || !mediaCache || !mediaCache.hasData()) {
          __uploadFailed(dispatch);
          return;
        }

        // 更新正在上传的媒体状态
        dispatch({
          type: FJActionConstant.CLOUD_SYNC_START,
          data: media,
        });
        dispatch(this.updateALLCloudStatusAction());

        try {
          await mediaCache.initData();
          let blob = mediaCache.getBlob();
          let cloudData = process.env.SERVE_ENV === 'local' ? {uid: uid, key: media.id} : {key: media.id}
          try {
            let code = await FJNetworkStore.checkMediaWhenCloudSync(cloudData);
            switch (code) {
              case 200: {

                // 已存在，直接成功
                __uploadCompleted(dispatch);
                break;
              }
              case 213: {

                // 没权限，空间不够
                // 显示空间不足的UI
                __uploadFull();
                break;
              }
              case 404:

                // 上传素材
                FJNetworkStore.uploadToS3(blob, key, (response) => {
                  switch (response.type) {
                    case "progress":
                      if (isExpired()) return;
                      FJCloudStore.setMediaUploadIngProgress((response.data.loaded / response.data.total) * 0.9);
                      dispatch(this.updateALLCloudStatusAction());
                      break;
                    case "done":
                      if (isExpired()) return;

                      // 如果是视频或者图片，则还需要上传封面图到s3
                      if (media.type !== FJMedia.MediaType().AUDIO) {
                        let cover = FJUtil.dataURLToBlob(media.thumbnail);
                        let coverKey = FJUtil.getS3CoverKey(media);

                        // eslint-disable-next-line max-nested-callbacks
                        FJNetworkStore.uploadToS3(cover, coverKey, (res) => { // 上传封面图
                          switch (res.type) {
                            case "progress":
                              break;
                            case "done":
                              if (isExpired()) return;
                              __uploadMediaData(dispatch, blob);
                              break;
                            case "error":
                              if (isExpired()) return;
                              if (res.msg.indexOf('aborted') !== -1) {
                                FJCloudStore.clearUploadMedia();
                                dispatch(this.doCheckWhenCloudSyncAction())
                              } else {
                                __uploadFailed(dispatch);
                              }
                              break;
                          }
                        });
                      } else {
                        __uploadMediaData(dispatch, blob);
                      }
                      break;
                    case "error":
                      if (isExpired()) return;
                      if (response.msg.indexOf('aborted') !== -1) {
                        FJCloudStore.clearUploadMedia();
                        dispatch(this.doCheckWhenCloudSyncAction())
                      } else {
                        __uploadFailed(dispatch);
                      }
                      break;
                  }
                });
                break;
              default:
                if (isExpired()) return;
                __uploadFailed(dispatch);
            }
          } catch (e) {
            if (e.statusText === 'abort') {
              FJCloudStore.clearUploadMedia();
              dispatch(this.doCheckWhenCloudSyncAction())
            } else {
              __uploadFailed(dispatch);
            }
          }
        } catch (e) {
          console.log(e);
          __uploadFailed(dispatch);
        }
      }
    },

    /**
     * @description 重新上传失败的
     * @returns {Function}
     */
    reUploadFilesOfFailAction: function () {
      return (dispatch) => {
        if (this._tryAgainCloudTimeout) {
          clearTimeout(this._tryAgainCloudTimeout);
          this._tryAgainCloudTimeout = null;
        }
        dispatch(this.doCheckWhenCloudSyncAction())
      }
    },

    /**
     * @description 显示还有媒体库存在正在上传中/上传失败的素材弹窗
     * @param goOnCallback
     * @returns {Function}
     */
    showCloudSyncingModal: function (goOnCallback) {
      return (dispatch, getState) => {
        let data = {
          headerText: FJLocalStore._('cloud-syncing-title'),
          bodyText: FJLocalStore._('cloud-syncing-desc'),
          cancelType: 'cancel',
          hasCancel: true,
          onCancel: (hide, type) => {
            hide();
            if (type !== 'icon') {
              goOnCallback('continue');
            }
          },
          onSubmit: (hide) => {
            hide();
            dispatch(this.reUploadFilesOfFailAction())
          },
          cancelText: FJLocalStore._('leave'),
          submitText: FJLocalStore._('wait')
        };
        dispatch(FJModalAction.showConfirmModalAction(data));
      };
    },

    /**
     * @description 添加上传失败的media 原因是空间已满
     * @param media
     * @returns {{data: *, type: *}}
     */
    addCloudFullMediaAction: function (media) {
      return (dispatch, getState) => {
        const state = getState();
        let cloudFUllMediaList = state.cloud.cloudFUllMediaList;
        cloudFUllMediaList = JSON.parse(JSON.stringify(cloudFUllMediaList));
        cloudFUllMediaList.push(media);
        dispatch({
          type: FJActionConstant.ADD_CLOUD_FULL_MEDIA,
          data: cloudFUllMediaList
        });
      }
    },

    /**
     * @description 清除上传失败的(media原因是空间已满)
     * @returns {{type: *}}
     */
    clearCloudFullMediaAction: function () {
      return {
        type: FJActionConstant.CLEAR_CLOUD_FULL_MEDIA,
      }
    }
  }
})();

export default FJCloudAction;
